module.exports = __webpack_public_path__ + "app-static/img/15.4cc2e461.png";